import { Fragment, type ReactElement } from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import type { KNDetailsPopoverSectionProps } from './types'

const KNDetailsPopoverSection = ({ header, description, items }: KNDetailsPopoverSectionProps): ReactElement | null => {
  if (!header && !description && items.length === 0) {
    return null
  }
  return (
    <Stack
      direction="column"
      sx={{
        paddingY: 1,
      }}
    >
      {header && (
        <Typography
          color="inherit"
          variant="p6"
          sx={{
            paddingX: 2,
            paddingY: 0.25,
          }}
        >
          {header}
        </Typography>
      )}
      {description && (
        <Typography
          color="inherit"
          fontSize="0.875rem"
          sx={{
            paddingX: 2,
            paddingY: 0.25,
          }}
        >
          {description}
        </Typography>
      )}
      {items.map((item, index) => (
        // don't care about stability here
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>{item}</Fragment>
      ))}
    </Stack>
  )
}

export default KNDetailsPopoverSection
